<template>
  <div class="report-content">
    <div class="filter-block">
      <div class="filter-items">
        <div class="single-row large-col">
          <v-text-field v-model="formData.search" placeholder="Search By Driver Name" color="#ff9600" hide-details dense></v-text-field>
        </div>
        <div class="single-row">
          <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateComputed" label="Date Range" readonly v-bind="attrs" v-on="on" hide-details dense></v-text-field>
            </template>
            <v-date-picker v-model="dateRange" color="black" :max="startMax" range></v-date-picker>
          </v-menu>
        </div>

        <div class="single-row" v-if="filtersData !== undefined && $isIndigo">
          <v-autocomplete v-model="formData.branch" :items="branchList" label="Station" color="#ff9600" item-text="name" item-value="id" hide-details dense @change="fetchTripList"></v-autocomplete>
        </div>
        <div class="single-row" v-else-if="filtersData !== undefined">
          <v-autocomplete v-model="formData.branch" :items="branchList" label="Branch" color="#ff9600" item-text="name" item-value="id" hide-details dense></v-autocomplete>
        </div>
        <div class="filter-button">
          <v-btn color="#000" title="Reset" @click="resetFilters" small>Reset filters</v-btn>
          <v-btn color="#ff9600" title="Reset" light @click="fetchTripList" text><i class="fas fa-redo"></i></v-btn>
        </div>
      </div>
      <v-btn color="#18921d" @click="downloadReport" small
        >Download Reports
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="20px" viewBox="0 0 24 24" width="20px" fill="#ffffff">
          <g><rect fill="none" height="24" width="24" /></g>
          <g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z" /></g>
        </svg>
      </v-btn>
    </div>
    <div class="report-table">
      <v-data-table height="calc(100vh - 210px)" hide-default-footer :headers="headers" :items="filteredList" fixed-header :items-per-page="filteredList.length"></v-data-table>
    </div>
  </div>
</template>

<script>
import axios from "@/axios/axios-global";
import moment from "moment";
import VueExcel from "@/components/common/VueExcel";
export default {
  name: "TripPendingReport",
  data() {
    return {
      menu: false,
      modal: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateRange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      formData: { startdate: -1, enddate: -1, branch: -1, reporttype: -1, search: "" },
      filtersData: undefined,

      today: moment().format("YYYY-MM-DD"),
      startMax: moment().format("YYYY-MM-DD"),
      endMin: "",
      endMax: "",

      headers: [
        { text: "Driver Name", value: "driverName" },
        { text: "Driver Mobile", value: "driverMobile" },
        { text: "Total Trips", value: "totalTrips" },
        { text: "Not Started Trips", value: "notStartedTrips" },
        { text: "Not Ended Trips", value: "notEndedTrips" },
        { text: "Driver Ended Trips", value: "driverEndedTrips" },
        { text: "Admin Ended Trips", value: "adminEndedTrips" },
      ],
      tripList: [],
    };
  },
  watch: {
    dateRange() {
      if (this.dateRange[0]) {
        if (this.dateRange[1]) {
          if (this.dateRange[0] > this.dateRange[1]) {
            this.startDate = moment(this.dateRange[1]).format("YYYY-MM-DD");
            this.endDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
          } else {
            this.startDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
            this.endDate = moment(this.dateRange[1]).format("YYYY-MM-DD");
          }
          this.fetchTripList();
          this.menu1 = false;
        }
      }
    },
  },
  mounted() {
    const branchListFromStorage = localStorage.getItem("branchList");
    try {
      this.branchList = branchListFromStorage ? JSON.parse(branchListFromStorage) : [];
    } catch (error) {
      console.error("Error parsing branchList from localStorage:", error);
      this.branchList = [];
    }
    this.getFilters();
    this.fetchTripList();
  },
  methods: {
    async getFilters() {
      const response = await axios.get("settings/filter");
      this.filtersData = response.data;
    },
    resetFilters() {
      (this.dateRange = [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]),
        (this.startDate = moment().format("YYYY-MM-DD")),
        (this.endDate = moment().format("YYYY-MM-DD")),
        (this.formData = { startdate: -1, enddate: -1, branch: -1, reporttype: -1, search: "" }),
        this.fetchTripList();
    },
    reloadTrips() {},

    async fetchTripList() {
      this.formData.startdate = this.convertToMillisecond(this.startDate, "YYYY MM DD");
      this.formData.enddate = this.convertToMillisecondEnd(this.endDate, "YYYY MM DD");
      const response = await axios.post("report/pending-trips", this.formData);
      console.log(response);
      if (response.status === 200) {
        this.tripList = response.data.message;
      }
    },
    downloadReport() {
      const reportData = this.tripList.map(item => ({
        driverName: item.driverName || "",
        driverMobile: item.driverMobile || "",
        totalTrips: item.totalTrips || 0,
        notStartedTrips: item.notStartedTrips || 0,
        notEndedTrips: item.notEndedTrips || 0,
        driverEndedTrips: item.driverEndedTrips || 0,
        adminEndedTrips: item.adminEndedTrips || 0,
      }));

      reportData.unshift({
        driverName: "Driver Name",
        driverMobile: "Driver Mobile",
        totalTrips: "Total Trips",
        notStartedTrips: "Not Started Trips",
        notEndedTrips: "Not Ended Trips",
        driverEndedTrips: "Driver Ended Trips",
        adminEndedTrips: "Admin Ended Trips",
      });

      VueExcel.methods.downloadExcelSheet(
        reportData,
        "Pending Trips Report",
        { skipHeader: true }
      );
    }

  },
  computed: {
    dateComputed() {
      let start = "";
      let end = "";
      if (this.dateRange[0] > this.dateRange[1]) {
        start = moment(this.dateRange[1]).format("MMM DD");
        end = moment(this.dateRange[0]).format("MMM DD");
      } else {
        start = moment(this.dateRange[0]).format("MMM DD");
        end = moment(this.dateRange[1]).format("MMM DD");
      }
      return `${start} ~ ${end}`;
    },

    filteredList() {
      const searchValue = (this.formData.search || "").toLowerCase();

      return this.tripList.filter((item) => {
        const driverName = (item.driverName || "").toLowerCase();
        const driverMobile = String(item.driverMobile || "");

        const matchesName = driverName.includes(searchValue);
        const matchesMobile = driverMobile.includes(searchValue);

        return matchesName || matchesMobile;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  gap: 20px;

  //   align-items: flex-start;
  .filter-block {
    padding: 10px 10px 0;
    display: flex;
    justify-content: space-between;
    .filter-items {
      justify-content: center;
      display: flex;
      padding: 0 10px;
      gap: 20px;
      .single-row {
        width: 250px;
      }
    }
    .filter-button {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    ::v-deep .v-btn {
      color: #fff;
      font-weight: bold;
    }
  }
  .report-table {
  }
}
</style>
